<div class="full layout-col">
  <mat-tab-group class="full" animationDuration="0" elderTabGroupRouting="optimizationTab">
    <mat-tab
      label="{{ 'optimization.schedule.titlePlural' | translate }}"
      elderTab="optimization-schedule"
    >
      <app-optimisation-schedule-settings></app-optimisation-schedule-settings>
    </mat-tab>
    <mat-tab label="{{ 'jssp.settings' | translate }}" elderTab="jssp-settings">
      <elder-basic-pane-layout class="full">
        <elder-pane>
          <app-jssp-settings-browser class="flex"></app-jssp-settings-browser>
        </elder-pane>
      </elder-basic-pane-layout>
    </mat-tab>
  </mat-tab-group>
</div>
